module.exports = __webpack_public_path__ + "media/images/emblems/Signy-Avenex-coat_of_arms-3ffaaaa2bf3f7149fd305a6ee3cb1ade.svg";